import React, {useEffect, useMemo, useState} from 'react'
import PageLayout from '../../../components/layout/PageLayout'
import WizButton from '../../../components/button/WizButton'
import useNavigation from '../../../hooks/useNavigation'
import Text from '../../../components/text/Text'
import TableLayout from '../../../components/table/TableLayout'
import TableItem from '../../../components/table/TableItem'
import WizTag from '../../../components/tag/WizTag'
import useQueryLeaderboardBanner from '../../../hooks/api/banner/useQueryLeaderboardBanner'
import {IBanners} from '../../../apis/banner/getLeaderboardBanner'
import WizPagination from '../../../components/pagination/WizPagination'
import {useImage} from '../../../utils/image'

import IconCopy from '../../../assets/images/ic_copy.svg'
import WizImage from '../../../components/image/WizImage'
import LeaderboardBannerItem from '../../../features/page/leaderboard/banner/LeaderboardBannerItem'

interface IProps {
    className?: string
}

const LeaderboardBannerPage: React.FC<IProps> = ({className}) => {
    const {goBannerCreate, goBannerDetail} = useNavigation()
    const {renderImage} = useImage()

    const [currentPage, setCurrentPage] = useState(1)

    const {data, pageInfo, refetch} = useQueryLeaderboardBanner(currentPage)

    const advertisementList = useMemo(() => {
        const list: IBanners[] = []
        data?.filter(e => e?.placement?.at(0) !== 'landing-popup')?.map(item => list.push(item))
        list?.sort((a, b) => b?.priority - a?.priority)
        return list
    }, [data])

    useEffect(() => {
        refetch()
    }, [currentPage])

    return (
        <PageLayout title={'Leaderboard Banner'} className={className}>
            <WizButton text={'Create Banner'} type={'primary'} onClick={goBannerCreate} />

            <TableLayout className={'mt-[40px]'}>
                {advertisementList?.map(item => (
                    <TableItem className={' sm:px-[0px]'} onClick={() => goBannerDetail(item?.id)}>
                        <div className={'flex items-center justify-center gap-x-[20px] sm:gap-x-[10px] md:truncate'}>
                            <div className={'mx-auto space-y-[3px]'}>
                                <Text className={'text-font02 text-ti1 md:text-ti3 text-center'}>Type</Text>

                                <Text className="text-ti2 text-center text-font01">
                                    {item?.placement?.at(0) === 'leaderboard'
                                        ? 'Leaderboard'
                                        : item?.placement?.at(0) === 'tradermap'
                                        ? 'Tradermap'
                                        : 'Landing'}
                                </Text>
                            </div>
                            <div className={'mx-auto space-y-[3px]'}>
                                <Text className={'text-font02 text-ti1 md:text-ti3 text-center'}>ID</Text>
                                <div
                                    className="flex items-center gap-x-[5px]"
                                    onClick={e => {
                                        e.stopPropagation()
                                        e.preventDefault()
                                        try {
                                            navigator.clipboard.writeText(item?.id)
                                            alert('Copied to clipboard!')
                                        } catch (err) {
                                            alert('Failed to copy!')
                                        }
                                    }}>
                                    <Text className="text-body2 text-center text-font01">{item?.id}</Text>
                                    <WizImage src={IconCopy} className="w-4 fill-font01" />
                                </div>
                            </div>
                            <div className={'mx-auto space-y-[3px] '}>
                                <Text className={'text-font02 text-ti1 md:text-ti3 text-center'}>Status</Text>
                                {item?.is_active ? (
                                    <WizTag textClassName={'mx-auto'} state={true}>
                                        Active
                                    </WizTag>
                                ) : (
                                    <WizTag textClassName={'mx-auto'} state={false}>
                                        DeActive
                                    </WizTag>
                                )}
                            </div>
                            <div className={'mx-auto space-y-[3px]'}>
                                <Text className={'text-font02 text-ti1 md:text-ti3 text-center'}>Priority</Text>
                                <Text className={'text-center text-ti2 text-font01'}>{item?.priority || '0'}</Text>
                            </div>
                            <div className={'mx-auto space-y-[3px] md:truncate'}>
                                <Text className={'text-font02 text-ti1 md:text-ti3 text-center'}>Link</Text>
                                <Text className={'text-center md:truncate'}>{item?.button?.link || '-'}</Text>
                            </div>
                        </div>
                        <div className={'min-h-[320px] sm:min-h-[270px]'}>
                            <LeaderboardBannerItem data={item} />
                        </div>
                    </TableItem>
                ))}
            </TableLayout>

            <WizPagination
                totalPage={pageInfo?.total_count}
                currentPage={currentPage}
                onPageChange={item => setCurrentPage(item)}
            />
        </PageLayout>
    )
}

export default LeaderboardBannerPage
